import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { RBAC_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { UserListTable } from '@/features/users/components/UserListTable';

export const Route = createFileRoute('/_auth/users/')({
  beforeLoad: () => requirePermission(RBAC_PERMISSIONS.USER_ALL_VIEW),
  component: () => (
    <ErrorBoundary moduleName="Users">
      <Suspense fallback={<PageLoader />}>
        <UserListTable
          title="All Users"
          userTypeIds={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
          showAllTypes
        />
      </Suspense>
    </ErrorBoundary>
  ),
});
